import {Timestamp} from "firebase/firestore";

export const DEFAULT_MEDICAL_ORGANIZATION = {
  id: '',
  name: '',
  address: '屏東縣屏東市',
  longitude: 0,
  latitude: 0,
  progressWeb: '',
  region: '',
  telephone: '',
  category: '',
  appointmentWeb: '',
  officialWeb: '',
  vaccines: [],
  vaccineId: '',
  smokingCessation: false,
  icope: false,
  hpaPrevention: false,
  adultHealthScreening: false,
  vaccineCreatedAt: Timestamp.now(),
  createdAt: Timestamp.now(),
  updatedAt: Timestamp.now(),
};